import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useProfile } from '../context/ProfileContext';

const ProfileBanner = () => {
  const { isProfileComplete, setShowProfilePanel } = useProfile();

  if (isProfileComplete) return null;

  return (
    <motion.div 
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      className="bg-blue-600 text-white overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between text-sm">
        <div className="flex items-center gap-2">
          <SafeIcon name="Info" className="w-4 h-4" />
          <span>Complete your Agent Profile to personalize your outputs with a professional signature.</span>
        </div>
        <button 
          onClick={() => setShowProfilePanel(true)}
          className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded font-medium transition-colors"
        >
          Setup Profile
        </button>
      </div>
    </motion.div>
  );
};

export default ProfileBanner;